document.addEventListener("DOMContentLoaded", () => {
  let elementToMove = document.querySelector('p.bo-product-testimonial');
  let reviewToMove = document.querySelector('#shopify-block-AM2FHR0ZFMW5JN0tod__stamped_reviews_star_rating_badge_rBPX4h');
  const originalParent = document.querySelector('#product-info-6817193590842-template--16658000216122__main > div > div > div.product-form > div:nth-child(8)');

  // Function to handle the move based on window width
  const handleResize = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth <= 1000) {
      // Detach the element and move it (mobile)
      elementToMove.remove();
      reviewToMove.remove();
      const newParent = document.querySelector('div.product.product--thumbnails-left');
      newParent.insertBefore(elementToMove, newParent.firstChild);
      newParent.insertBefore(reviewToMove, newParent.firstChild);
    } else if (windowWidth >= 1024) {
      // Detach the element and move it (desktop)
      elementToMove.remove();
      reviewToMove.remove();
      const newParent = document.querySelector('div.product__info div.product-form');
      newParent.insertBefore(elementToMove, newParent.firstChild);
      newParent.insertBefore(reviewToMove, newParent.firstChild);
    } else {
      //do nothing
    }
  };

  // Handle the resize event
  window.addEventListener('resize', handleResize);

  // Initial call to set things up properly
  handleResize();
});

// Hide footer on cart
document.addEventListener("DOMContentLoaded", function() {
    // Check if the user is on the cart page
    if (window.location.pathname === '/cart') {
        // Find cart elements by its name(s) and hide it/them
        var hideCartElements = document.querySelectorAll('.shopify-section.shopify-section--footer, div#_sf-storefront-ProgramWidget');
        hideCartElements.forEach(function(element) {
            element.style.setProperty('display', 'none', 'important');
        });
    }
});

// Add css class 'has-items-animation' to activate cart item animation
document.addEventListener('DOMContentLoaded', function() {
  const cartCount = document.querySelector('cart-count');

  // Function to update the CSS class based on the count value
  function updateCartClass() {
    // Safely parse the number of items. If text is missing, default to 0.
    const countValue = parseInt(cartCount.textContent.trim() || '0', 10);

    // If cart count is 1 or more, add the class; otherwise remove it.
    if (countValue >= 1) {
      cartCount.classList.add('has-items-animation');
    } else {
      cartCount.classList.remove('has-items-animation');
    }
  }

  if (cartCount) {
    // Initial check on page load
    updateCartClass();

    // Create a MutationObserver to watch for changes in the cartCount’s text
    const observer = new MutationObserver(updateCartClass);

    observer.observe(cartCount, {
      childList: true, // watch for changes in direct child nodes
      subtree: true    // watch for changes in all descendant nodes
    });
  }
});